export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/drill.7c935a1.svg";